import type { PixelSprite } from '../types.js';
import { sprites as ancientPortal } from './ancientPortal.js';
import { sprites as aurora } from './aurora.js';
import { sprites as bambooGrove } from './bambooGrove.js';
import { sprites as bioluminescentPool } from './bioluminescentPool.js';
import { sprites as bonsaiGiant } from './bonsaiGiant.js';
import { sprites as colosseum } from './colosseum.js';
import { sprites as coralReef } from './coralReef.js';
import { sprites as crystalSpire } from './crystalSpire.js';
import { sprites as dragonNest } from './dragonNest.js';
import { sprites as eiffelTower } from './eiffelTower.js';
import { sprites as floatingIsland } from './floatingIsland.js';
import { sprites as geyser } from './geyser.js';
import { sprites as giantMushroom } from './giantMushroom.js';
import { sprites as giantSequoia } from './giantSequoia.js';
import { sprites as giantWaterfall } from './giantWaterfall.js';
import { sprites as glacierPeak } from './glacierPeak.js';
import { sprites as grandCanyon } from './grandCanyon.js';
import { sprites as hotSpring } from './hotSpring.js';
import { sprites as meteorCrater } from './meteorCrater.js';
import { sprites as mountFuji } from './mountFuji.js';
import { sprites as oasis } from './oasis.js';
import { sprites as operaHouse } from './operaHouse.js';
import { sprites as pagoda } from './pagoda.js';
import { sprites as sakuraEternal } from './sakuraEternal.js';
import { sprites as stBasils } from './stBasils.js';
import { sprites as tajMahal } from './tajMahal.js';
import { sprites as torii } from './torii.js';
import { sprites as volcano } from './volcano.js';
import { sprites as windmillGrand } from './windmillGrand.js';
import { sprites as worldTree } from './worldTree.js';
export const sprites: Readonly<Record<string, readonly PixelSprite[]>> = {
  ancientPortal,
  aurora,
  bambooGrove,
  bioluminescentPool,
  bonsaiGiant,
  colosseum,
  coralReef,
  crystalSpire,
  dragonNest,
  eiffelTower,
  floatingIsland,
  geyser,
  giantMushroom,
  giantSequoia,
  giantWaterfall,
  glacierPeak,
  grandCanyon,
  hotSpring,
  meteorCrater,
  mountFuji,
  oasis,
  operaHouse,
  pagoda,
  sakuraEternal,
  stBasils,
  tajMahal,
  torii,
  volcano,
  windmillGrand,
  worldTree,
};
